import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignBrowserComponent } from './sign-browser/sign-browser.component';
import { SignPageComponent } from './sign-page/sign-page.component';

const routes: Routes = [
  {
    path: '',
    component: SignBrowserComponent,
  },
  {
    path: 'sign/:id',
    component: SignPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
